import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';
import { transformTagNames } from '../../global/transform-tag-name';
import { Ratio } from '../aspect-ratio/ratio';

/**
 * @slot - content of the component
 * @slot footer - wb-button elements
 */
@Component({
  tag: 'wb-error-section',
  styleUrl: 'error-section.scss',
  shadow: true,
})
export class ErrorSectionComponent implements ComponentInterface {
  /** the image ratio*/
  @Prop({ reflect: false })
  public imageRatio: Ratio = '16x9';

  /** the image source (alternative to `srcSet`) */
  @Prop({ reflect: false })
  public imageSrc: string;

  /** the image source set (alternative to `src`) */
  @Prop({ reflect: false })
  public imageSrcSet: string;

  /** the aria label */
  @Prop({ reflect: false })
  public imageLabel: string;

  private TagNames = transformTagNames(this, 'wb-error-section', ['wb-aspect-ratio']);

  public render(): JSX.Element {
    const { WbAspectRatio } = this.TagNames;

    return (
      <Host class="wb-error-section">
        {this.imageSrc && [
          <WbAspectRatio ratio={this.imageRatio} class="image-mobile">
            <img src={this.imageSrc} alt={this.imageLabel} aria-label={this.imageLabel} />
          </WbAspectRatio>,
          <div
            class="image-desktop"
            title={this.imageLabel}
            style={{
              backgroundImage: `url(${this.imageSrc})`,
            }}
          />,
        ]}
        <div class="grid-width">
          <div class={{ content: true, 'no-image': !this.imageSrc }}>
            <slot />
            <div class="footer">
              <slot name="footer" />
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
